var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"whatsapp",attrs:{"href":_vm.destination}},[_c('b-img',{attrs:{"width":"70","src":require("@assets/images/whatsapp.svg"),"fluid":"","alt":"whatsapp"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }